import { jsx as _jsx } from "react/jsx-runtime";
import { TouchableOpacity } from "@kolmeo/ui-core";
import Icon from "../Icon";
const CameraBackButton = ({ onPress, ...props }) => {
    return (_jsx(TouchableOpacity, { ...props, onPress: onPress, bg: "white", borderRadius: 50, alignItems: "center", justifyContent: "center", children: _jsx(Icon, { type: "chevron-left", color: "gray", size: "lg" }) }));
};
export default CameraBackButton;
